<template>
  <div>
    <div id="gaesdrawwrapson">
      <!-- <div id="tempdraw"></div> -->
    </div>

    <div style="padding: 10px 0 0 10px">
      图表放大比例：
      <RadioGroup v-model="baifenbi" @on-change="changeBai">
        <Radio :label="100">100%</Radio>
        <Radio :label="200">200%</Radio>
        <Radio :label="400">400%</Radio>
        <Radio :label="800">800%</Radio>
        <Radio :label="1600">1600%</Radio>
        <Radio :label="3200">3200%</Radio>
      </RadioGroup>
    </div>
  </div>
</template>
<script>
var chart;
var list = [];
var waveList = [];
export default {
  data() {
    return {
      no: true,
      baifenbi: 100,
    };
  },
  methods: {
    reData(a, b) {
      list = a;
      waveList = b;
      var length = list.length;
      if (length >= 0 && length < 600) {
        this.baifenbi = 100;
      } else if (length >= 600 && length < 1500) {
        this.baifenbi = 200;
      } else if (length >= 1500) {
        this.baifenbi = 400;
      }
      this.draw();
    },
    draw() {
      var jiange = 24;
      if (this.baifenbi > 0 && this.baifenbi <= 400) {
        jiange = 24;
      } else if (this.baifenbi > 400 && this.baifenbi <= 1600) {
        jiange = 12;
      } else if (this.baifenbi > 1600 && this.baifenbi <= 3200) {
        jiange = 6;
      }
      document.getElementById("gaesdrawwrapson").innerHTML =
        '<div id="gaesdraw" style="width:' + this.baifenbi + '%"></div>';
      setTimeout(() => {
        var tt = document.getElementById("gaesdraw");
        chart = this.echarts.init(tt);
        this.option = {
          backgroundColor: "",
          /* title: {
          text: "油耗实时监测数据"
        }, */
          color: ["red", "blue"],
          grid: {
            x: 40,
            y: 40,
            x2: 30,
            y2: 50, //距离下边的距离
          },
          tooltip: {
            trigger: "axis",
            formatter(params) {
              var ad = params[1];
              params = params[0];

              var adv;
              if (ad != undefined) {
                adv = ad.value[1];
              } else {
                adv = "无";
              }
              return (
                '<div style="padding:6px;color:#fff">' +
                params.value[0] +
                "<br>剩油量：" +
                params.value[1] +
                "升" +
                "<br>发动机：" +
                params.value[2] +
                "<br>速度：" +
                params.value[3] +
                "km/h" +
                "<br>电阻值：" +
                params.value[4] +
                "</div>"
              );
              //return "当前时间：" +params.value[0] + "<br>剩余油量：" + params.value[1]+ "<br>录入油量：" + adv;
            },
            axisPointer: {
              animation: false,
            },
          },
          /* dataZoom: [
              {
                type: "inside",
                //type: "slider",
                //yAxisIndex:[0],
                //xAxisIndex:[0],
                start: 0, //放大起点
                //end: this.end(list),
                end: 100, //放大终点
                //startValue:10,
                //zoomLock:true
              },
            ] ,*/
          xAxis: {
            type: "time",
            minInterval: 1,
            maxInterval: 3600 * jiange * 1000,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: "油针数据",
              type: "line",
              data: list,
              connectNulls: true,
              // 设置折线弧度，取值：0-1之间
              smooth: 0,
              // 设置折线上圆点大小
              symbolSize: 1,
              showAllSymbol: true,
              itemStyle: {
                normal: {
                  // color: "#6cb041",
                  lineStyle: {
                    width: 2, //设置线条粗细
                  },
                },
              },
              /* areaStyle: {
                //color: "#ff7c25",
                opacity: "0.3",
                //shadowColor: "#000",
                // shadowBlur: 50,
                //shadowOffsetX:0,
                // shadowOffsetY:-10
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#ffc490",
                  },
                  {
                    offset: 1,
                    color: "#FFF",
                  },
                ]),
              }, */
            },
            /* {
            name: "录入数据",
            type: "line",
            data: this.list2
          } */
            {
              symbolSize: 8,
              label: {
                show: true,
                offset: [-2, -26],
                color: "#333",
                align: "left",
                fontWeight: 400,
                lineHeight: 18,
                fontSize: 14,
                formatter(params) {
                  var data = params.data;
                  return data[0] + "\n" + data[3] + "：" + data[2] + "升";
                  //return "当前时间：" +params.value[0] + "<br>剩余油量：" + params.value[1]+ "<br>录入油量：" + adv;
                },
              },
              data: waveList,
              type: "scatter",
            },
          ],
        };
        chart.setOption(this.option, true); //true重绘
      }, 200);
    },
    changeBai(v) {
      this.draw();
    },
  },
  //调用
  mounted() {
    this.draw();
  },
  destroyed() {},
  //gaesdraw
};
</script>
<style>
#gaesdrawwrapson {
  width: calc(100% - 20px);
  height: 300px;
  overflow: auto;
  background: #fdf2ed;
  margin: 0 10px;
}
#gaesdraw {
  height: 280px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/oil/oilDraw.vue